/**
 * Dashboard summary API endpoints
 */

import { fetchApi } from '../core';
import type {
  AdminDashboardSummary,
  InstructorDashboardSummary,
  PlatformDashboardSummary,
  StudentDashboardSummary,
} from '../types';

export function getAdminSummary(componentName: string = 'Unknown') {
  return fetchApi<AdminDashboardSummary>('/dashboard/admin', {}, componentName);
}

export function getInstructorSummary(componentName: string = 'Unknown') {
  return fetchApi<InstructorDashboardSummary>('/dashboard/instructor', {}, componentName);
}

export function getStudentSummary(componentName: string = 'Unknown') {
  return fetchApi<StudentDashboardSummary>('/dashboard/student', {}, componentName);
}

export function getPlatformSummary(componentName: string = 'Unknown') {
  return fetchApi<PlatformDashboardSummary>('/platform/dashboard', {}, componentName);
}
